var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCameraReport(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 58.332,
    height: 52.799,
    viewBox: "0 0 58.332 52.799",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "camera_icon",
    "data-name": "camera icon",
    transform: "translate(1.5 1.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon_material-photo-camera",
    "data-name": "Icon material-photo-camera",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_396",
    "data-name": "\\uD328\\uC2A4 396",
    d: "M26.77,19.985A6.785,6.785,0,1,1,19.985,13.2,6.785,6.785,0,0,1,26.77,19.985Z",
    transform: "translate(7.681 7.984)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_397",
    "data-name": "\\uD328\\uC2A4 397",
    d: "M22.366,3,17.3,8.533H8.533A5.549,5.549,0,0,0,3,14.066v33.2A5.549,5.549,0,0,0,8.533,52.8H52.8a5.549,5.549,0,0,0,5.533-5.533v-33.2A5.549,5.549,0,0,0,52.8,8.533h-8.77L38.966,3Zm8.3,41.5A13.833,13.833,0,1,1,44.5,30.666,13.838,13.838,0,0,1,30.666,44.5Z",
    transform: "translate(-3 -3)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 3
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCameraReport);
export default __webpack_public_path__ + "static/media/camera_report.79fd4a89b8cfcd2e0591e287b610cd7a.svg";
export { ForwardRef as ReactComponent };